import React from "react";

/**
 * Small inline SVG spinner for "refreshing" / "loading" UI signals that sit
 * next to text in a row (header, status line, badges).
 *
 * Distinct from `GridSpinner` (which is a centered overlay with a backdrop
 * for full-grid loading states). Use `InlineSpinner` wherever a single
 * humanized "in-flight" hint is needed next to other content.
 *
 * Default size is 1em so it scales with surrounding font-size automatically.
 * Pass `size` (e.g. "0.9em", "12px") to override.
 *
 * Color is inherited via `currentColor` so a parent's text color (e.g.
 * `#FDB824` for the status line, white for the header button) carries
 * through without prop wiring.
 *
 * Animation uses Tailwind's `animate-spin` (matches GridSpinner).
 */
const InlineSpinner = ({
  size = "1em",
  className = "",
  ariaLabel = "loading",
}) => (
  <svg
    aria-label={ariaLabel}
    role="status"
    className={`inline-block animate-spin ${className}`}
    style={{ width: size, height: size, verticalAlign: "-0.15em" }}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    {/* faint ring + arc that rotates — same visual idiom as GridSpinner */}
    <circle
      cx="12"
      cy="12"
      r="9"
      stroke="currentColor"
      strokeWidth="3"
      opacity="0.25"
    />
    <path
      d="M21 12a9 9 0 0 0-9-9"
      stroke="currentColor"
      strokeWidth="3"
      strokeLinecap="round"
    />
  </svg>
);

export default InlineSpinner;
